import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 120px;
`;

export const Digit = styled.div`
  font-size: 40px;
  text-shadow: 5px 5px 5px rgba(255, 255, 255, 0.3);
  width: 25px;
  text-align: center;

  &:nth-child(3) {
    width: 10px;
  }
`;
